module.exports = __webpack_public_path__ + "static/media/img78.759f96e6.jpg";